/**
 * Stable CSS class names for E2E — Order fraud control page.
 */
export const OFC = {
    root: 'order-fraud-control-page',
    loadingWrap: 'order-fraud-control-page__loading-wrap',
    headerRow: 'order-fraud-control-page__header-row',
    headerTitle: 'order-fraud-control-page__title',
    gridWrap: 'order-fraud-control-page__grid-wrap',
    tryAgainButton: 'order-fraud-control-input--button-try-again',
    tryAgainLink: 'order-fraud-control-input--link-order-id',
} as const;

